import { twMerge } from 'tailwind-merge';
import type { ScanServiceStatus } from '@witmetrics/utils';
import { toTitleCase } from '@witmetrics/utils/strings';
import { classes, getStatusColors } from './utils';

export type ScanServiceStatusChipProps = {
  className?: string;
  labelClassName?: string;
  status: ScanServiceStatus;
};

export default function ScanServiceStatusChip({
  className,
  status,
}: ScanServiceStatusChipProps) {
  const label = toTitleCase(status.replace('_', ' '));
  return (
    <span
      className={twMerge(classes.label, getStatusColors(status), className)}>
      {label}
    </span>
  );
}
